import { State, Action, StateContext, Selector, NgxsOnInit, Store } from '@ngxs/store';
import { BreakpointActions } from './breakpoint.actions';
import { Breakpoint } from '../models/breakpoint.enum';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { combineLatest } from 'rxjs';
import { takeUntil, map, distinctUntilChanged, filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';

export class BreakpointStateModel {
  public breakpoint: Breakpoint;
}

@State<BreakpointStateModel>({
  name: 'breakpoint',
  defaults: {
    breakpoint: null
  }
})
@Injectable()
export class BreakpointState implements NgxsOnInit {
  @Selector()
  static getBreakpoint(state: BreakpointStateModel) {
    return state.breakpoint;
  }

  @Selector()
  static getBreakpointLabel(state: BreakpointStateModel) {
    const keys = ['(max-width: 374px)', '(max-width: 599px)', '(max-width: 959px)', '(max-width: 1439px)', '(min-width: 1440px)'];
    return keys[state.breakpoint];
  }

  @Action(BreakpointActions.SetBreakpoint)
  setBreakpoint(context: StateContext<BreakpointStateModel>, action: BreakpointActions.SetBreakpoint) {
    context.patchState({
      breakpoint: action.breakpoint
    });
  }

  constructor(
    private breakpointObserver: BreakpointObserver,
    private store: Store
  ) { }

  ngxsOnInit(context: StateContext<BreakpointStateModel>) {
    // < 375
    const xsmall$ = this.breakpointObserver.observe([
      '(max-width: 374px)'
    ]);

    // < 600
    const small$ = this.breakpointObserver.observe([
      '(max-width: 599px)'
    ]);

    // < 601 - 959
    const medium$ = this.breakpointObserver.observe([
      '(max-width: 959px)'
    ]);

    // 960 - 1439
    const large$ = this.breakpointObserver.observe([
      '(max-width: 1439px)'
    ]);

    // > 1440
    const xlarge$ = this.breakpointObserver.observe([
      '(min-width: 1440px)'
    ]);

    // Observe all breakpoints
    combineLatest(xsmall$, small$, medium$, large$, xlarge$)
      .pipe(
        map(([xsmall, small, medium, large, xlarge]) => {
          return xsmall.matches ? Breakpoint.XSmall :
            small.matches ? Breakpoint.Small : 
            medium.matches ? Breakpoint.Medium : 
            large.matches ? Breakpoint.Large : 
            xlarge.matches ? Breakpoint.XLarge : 
            null;
        }),
        distinctUntilChanged(),
        filter(point => point != null) // Returns 'undefined' when rapidly resizing
      ).subscribe((breakpoint: Breakpoint) => {
        context.dispatch(new BreakpointActions.SetBreakpoint(breakpoint));
      });
  }
}
